import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import WebDrawer from '../../../components/web-drawer'
import {renderLayoutsSwitch} from '../../../components/optimizely/utils/contentRenderer'
import {GDIDynamicContentProvider} from '../../../components/optimizely/gdi/utils/gdi-dynamic-content-context'
import {resolveGDIStyles, GDI_TEXT_BLOCK_FIELD_MAP} from '../../../components/optimizely/gdi/utils/gdi-styles'

/**
 * Generic gift-card drawer that renders a CMS-driven title (with optional CMS
 * styling, falling back to a provided default) and a CMS content area rendered
 * entirely from Optimizely blocks inside the drawer body.
 */
const GiftCardContentDrawer = ({
    isOpen,
    onClose,
    titleBlock,
    fallbackTitle,
    contentItems = [],
    dynamicContentValue,
    bodyTestId
}) => {
    const cmsTitle = titleBlock?.TextForWeb
        ? titleBlock.TextForWeb.replace(/<[^>]*>/g, '').trim()
        : null
    const {styles: cmsTitleStyles} = resolveGDIStyles(
        titleBlock?.GDITextBlockStylesPerViewType,
        GDI_TEXT_BLOCK_FIELD_MAP
    )
    const cmsTitleSx = Object.keys(cmsTitleStyles).length > 0 ? cmsTitleStyles : null

    return (
        <WebDrawer
            isOpen={isOpen}
            onClose={onClose}
            title={cmsTitle || fallbackTitle}
            titleSx={cmsTitleSx}
            size="85vh"
        >
            <Box pb={4} data-testid={bodyTestId}>
                <GDIDynamicContentProvider value={dynamicContentValue}>
                    {contentItems.map((item, index) => (
                        <React.Fragment
                            key={
                                item?.ContentLink?.GuidValue ||
                                item?.ContentLink?.Id ||
                                `gift-card-drawer-content-${index}`
                            }
                        >
                            {renderLayoutsSwitch(item?.ContentLink?.Expanded)}
                        </React.Fragment>
                    ))}
                </GDIDynamicContentProvider>
            </Box>
        </WebDrawer>
    )
}

GiftCardContentDrawer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    titleBlock: PropTypes.object,
    fallbackTitle: PropTypes.string,
    contentItems: PropTypes.array,
    dynamicContentValue: PropTypes.object,
    bodyTestId: PropTypes.string
}

export default GiftCardContentDrawer
